export default __webpack_public_path__ + "static/qr-office-5x-big-801d96bf817c3de179d06fd064e54807.webp";